"use strict";
exports.__esModule = true;
var regex = /^[a-z]+$/i;
function default_1(s) {
    return regex.test(s.toLowerCase());
}
exports["default"] = default_1;
;
